import MasterApi from './MasterApi';

export default class TankHeader extends MasterApi {
  constructor() {
    super();
    this.masterName = 'tank_header';
  }
}
